import React, { useState, useEffect, useContext, useRef } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import PartService from "../Controller/PartController"
import PartsDetailModal from "./PartsDetail";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Common from '../../Common/Common';
import Swal from 'sweetalert2';
import HelpSite from "../../Common/HelpLink";
import SageService from '../../Sage/Controller/SageController';
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import { useTranslation } from 'react-i18next';
import ColumnOptionDropDown from "../../Lead/Views/LeadForms/ColumnOptionDropDown";
import Cookies from "js-cookie";
import StockBatchSearchModal from "./PartForms/StockBatchSearchModal";
import SearchStockSerialModal from "./PartForms/SearchStockSerialModal";
import { formatDateWithFns } from '../../Common/DateInputFormat';
import useDateFormat from '../../Common/fetchDateFormat';
import LockReleaseService from "../../Setup/controller/LockReleaseController/LockModuleController";

import QuickbookService from '../../Quickbook/QuickbookController';
import XeroService from '../../Xero/XeroController';
import StockMovementModal from "./PartForms/partmovement";
import CustomerService from "../../Customer/Controller/CustomerController";
import MultiSearchDropDown from "../../Common/MultiSearchDropDown";
import JasperReportService from '../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../config/axiosInstance';
import Draggable from 'react-draggable';

import ReportService from "../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../Setup/controller/TermsConditionController/TermsConditionController";
import BASE_URL from "../../../config/config";
import { PDFDocument } from "pdf-lib";
import CompanySetupController from "../../SuperAdmin/Controller/Client/SACompanyListController";
import StockCategoryListPage from "../../Setup/views//StockCategory/StockCategoryList";
import ImportTableService from "../../Setup/controller/ImportTables/ImportTable";
function PartListPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };
  const RoleID = localStorage.getItem('RoleID');
  const HelpLink = localStorage.getItem('HelpLink');
  const location = useLocation();
  const url = new URL(window.location.origin + location.pathname);
  const pathname = "/part/part-list"
  const tableRef = useRef();
  const FormAction = "/PartList";
  //  FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
  const [modalInstance, setModalInstance] = useState(null);
  const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
  const [modalInstanceCustomerDetail, setModalInstanceCustomerDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const { theme, toggleTheme } = useContext(ThemeContext);
  let accordTheme = "accordion-header-light";
  const [selectedId, setSelectedId] = useState("0");
  if (theme == "dark") {
    accordTheme = "accordion-header-dark";
  }
  const [partList, setPartData] = useState([]);
  const [filteredParts, setFilteredParts] = useState([]);
  const [isSerialModalOpen, setIsSerialModalOpen] = useState(false);
  const [isBatchModalOpen, setIsBatchModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const [searchQuery, setSearchQuery] = useState('');
  const [poCount, setPOCount] = useState(0);
  const [StockID, setStockID] = useState("0");
  const [multipleIds, setMultipleIds] = useState([]);
  const CompanyID = localStorage.getItem("CompanyID");
  const UserID = localStorage.getItem("UserID");
  const activeDateFormat = useDateFormat();
  const [recentSearches, setRecentSearches] = useState([]);
  const [isMovementModalOpen, setIsMovementModalOpen] = useState(false);
  const [isStockDiscount, setIsStockDiscount] = useState(false);
  const setSortConfigInCookie = (config) => {
    Cookies.set(`PartSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
  };
  const getSortConfigFromCookie = () => {
    const sortCookie = Cookies.get(`PartSort_${CompanyID}_${UserID}`);
    return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
  };
  const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());

  const setPageSizeInCookie = (pageSize) => {
    document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
  };

  const getPageSizeFromCookie = () => {
    const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
    return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
  };
  const [pageSize, setPageSize] = useState(getPageSizeFromCookie());

  useEffect(() => {
    UserLockRelease();
    fetchParts(currentPage, pageSize);
  }, [currentPage, pageSize]);

  useEffect(() => {
    fetchParts(currentPage, pageSize);
  }, [sortConfig]);

  const UserLockRelease = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "2");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "3");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "4");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "5");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "6");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "7");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "8");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "9");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "10");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "15");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "17");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "18");

    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };

  const fetchParts = async (page, size) => {
    try {

      setLoading(true);
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };

      const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
      const PageSize = size.toString();


      const data = await PartService.GetAllNewParts(redirectCallback, Start.toString(), PageSize.toString(),
        searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), "0", searchColumns.toString());
      setFilteredParts(data);
      setPartData(data);


      const leadCount = await PartService.GetPartCount(redirectCallback, searchQuery, searchColumns.toString());
      setPOCount(leadCount[0].TotalRecords);
      setTotalPages(Math.ceil(leadCount[0].TotalRecords / size));
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
    finally {
      setLoading(false); // Stop loading after fetching
    }
  };
  async function fetchSearchLog() {
    try {

      const searchList = await CustomerService.GetSearchLog("4");
      setRecentSearches(searchList);
    } catch (error) {
      console.error('Error fetching Roles:', error);
    }
  }
  useEffect(() => {
    IsModuleAssigned();
    fetchSearchLog();
    fetchParts("0", pageSize);
  }, []);


  const handleCloseModal = async (isChanged) => {


    const closeModal = async () => {
      await PartService.UnLockPart(localStorage.getItem('StockID'));
      if (localStorage.getItem('HasRecordUpdated') == "1") {

        fetchParts("0", pageSize);
      }
      setMultipleIds([]);
      setIsModalOpen(false);
    };

    if (isChanged != true) {
      closeModal();
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to close this record?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, close it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        closeModal();
      }
    });
  };
  const handleBatchCloseModal = () => {
    setStockID("0");
    setIsBatchModalOpen(false);
  };
  const handleSerialCloseModal = () => {
    setStockID("0");
    setIsSerialModalOpen(false);
  };
  const handleDeleteClick = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    if (multipleIds.length > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: `You are about to delete ${multipleIds.length} record(s). This cannot be undone!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t('confirmDelete')
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await PartService.DeletePart(redirectCallback, multipleIds);
            setMultipleIds([]);
            fetchParts("0", pageSize);
            setSelectedId("0");
            Swal.fire(
              t('deleted'),
              t('deleteSuccess'),
              'success'
            );
          } catch (error) {
            console.error('Error deleting job:', error);
            Swal.fire(
              'Error!',
              'There was a problem deleting the record.',
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to delete part.',
        'warning'
      );
    }
  };

  const handleCreatePartClick = () => {
    localStorage.setItem('StockID', "");
    localStorage.setItem('StockID', "0");
    localStorage.setItem('HasRecordUpdated', "0");
    setIsModalOpen(true);
  };
  const fetchPartDetail = async (PartID) => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const PartDetail = await PartService.GetPartByID(redirectCallback, PartID);
      return PartDetail;

    } catch (error) {
      console.error('Error fetching supplier details:', error);
    }
  };
  const handleEditClick = async (StockID) => {
    const IsAlreadyLeadID = localStorage.getItem('StockID');
    if (IsAlreadyLeadID) {
      await PartService.UnLockPart(IsAlreadyLeadID);
    }
    const PartDetail = await fetchPartDetail(StockID);
    if (PartDetail.length > 0) {
      localStorage.setItem('StockID', "");
      localStorage.setItem('StockID', StockID);
      localStorage.setItem('HasRecordUpdated', "0");
      setSelectedId(StockID);
      setIsModalOpen(true);

    }
  };

  const truncateText = (text, maxLength = 20) => {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };
  const getRowColor = (freeStock, rangeFrom, rangeTo) => {
    if (parseFloat(freeStock) < parseFloat(rangeFrom)) {

      return 'red';
    } else if (parseFloat(freeStock) > parseFloat(rangeTo)) {
      return 'blue';
    }
    return 'black'; // Default color or any other color you'd like
  };
  const filterParts = (color) => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }
    if (color === 'red') {
      setFilteredParts(partList.filter(part => getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) === 'red'));
    } else if (color === 'blue') {
      setFilteredParts(partList.filter(part => getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) === 'blue'));
    } else {
      // Reset to show all parts
      setFilteredParts(partList);
    }
  };
  const handleCheckboxChange = (event, id) => {
    event.stopPropagation();
    setSelectedId((prevSelectedId) => (prevSelectedId === id ? "0" : id)); // Toggle selection
    setMultipleIds((prevSelectedIds) => {
      if (event.target.checked) {
        return [...prevSelectedIds, id];
      } else {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      }
    });
  };
  const handleSynchronize = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }
    if (ID > 0) {
      Swal.fire({
        title: t('areYouSure'),
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Synchronize!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const postData = await PartService.SyncPartToFinancial(multipleIds);
            if (postData && postData.message === "Data saved successfully") {
              Swal.fire(
                'Success!',
                'The data has been processed and will be fully synced shortly.',
                'success'
              );
              await fetchParts("0", pageSize);
            }
          } catch (error) {
            console.error('Error Synchronizing data:', error);
            Swal.fire(
              'Error!',
              'There was a problem in synchronizing the record.',
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        'Error!',
        'Please select at least one record to synchronize.',
        'warning'
      );
    }

  };

  const handleSerialTracking = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }
    if (ID > 0) {
      const partDetail = await PartService.GetPartByID(redirectCallback, ID);
      if (partDetail[0].snt_SerialTracking > 0) {
        setIsSerialModalOpen(true);
      }
      else {
        Swal.fire(
          'Error!',
          'The serial tracking is not enabled for the selected part.',
          'error'
        );
      }
    }
    else {
      Swal.fire(
        'Error!',
        'Please select at least one record to synchronize.',
        'warning'
      );
    }

  };

  const handleBatchManagement = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }
    if (ID > 0) {
      const partDetail = await PartService.GetPartByID(redirectCallback, ID);
      if (partDetail[0].bit_BatchManagement > 0) {

        setSelectedId(selectedId);
        setIsBatchModalOpen(true);
      }
      else {
        Swal.fire(
          'Error!',
          'The batch management is not enabled for the selected part.',
          'error'
        );
      }
    }
    else {
      Swal.fire(
        'Error!',
        'Please select at least one record to synchronize.',
        'warning'
      );
    }

  };



  const redirecttoUnAuthorzied = () => {
    navigate('/Unauthorized'); // Redirect to the login page
  };

  const IsModuleAssigned = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      const Modules = await ModuleService.GetModuleByClientID(CompanyID, "4");
      if (Modules.length === 0) {
        Swal.fire(
          'UnAuthorzied Access!',
          'Sorry, You are not authorized to access this module.',
          'warning'
        );
        redirecttoUnAuthorzied();
      }
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };
  const handlePageChange = (page) => {
    setFilteredParts([]);
    setPartData([]);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);

    }
  };
  const handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    setPageSize(newPageSize);
    setPageSizeInCookie(newPageSize);
    setCurrentPage(1); // Reset to the first page
  };
  const handleSearchButtonClick = async () => {
    setCurrentPage(1); // Reset to first page
    setFilteredParts([]);
    setPartData([]);
    const query = searchQuery.toLowerCase(); // Use current searchQuery state
    let columnsToSearch = searchColumns.length > 0
      ? searchColumns.join(",")
      : "ALL";
    setSearchOptions(columnsToSearch);
    const leadData = await PartService.GetAllNewParts(redirectCallback, currentPage, pageSize.toString(),
      query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), "0", columnsToSearch.toString());
    setFilteredParts(leadData);
    setPartData(leadData);

    const leadCount = await PartService.GetPartCount(redirectCallback, searchQuery, columnsToSearch.toString());
    setPOCount(leadCount[0].TotalRecords);
    setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize)); // Set total pages dynamically

    const searchList = await CustomerService.GetSearchLog("4");
    setRecentSearches(searchList);
  };
  const handleSort = async (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const newConfig = { key, direction };
    setSortConfig(newConfig);
    setSortConfigInCookie(newConfig);
    setCurrentPage(1);

    setSortConfig({ key, direction });
    const porderData = await PartService.GetAllNewParts(redirectCallback, "1", pageSize.toString(),
      searchQuery.toString(), key.toString(), direction.toString(), "0", searchColumns.toString());

    const porderCount = await PartService.GetPartCount(redirectCallback, searchQuery, searchColumns.toString());

    setPOCount(porderCount[0].TotalRecords);
    setFilteredParts(porderData);
    setPartData(porderData);

    setTotalPages(Math.ceil(porderCount[0].TotalRecords / pageSize));
  };

  const defaultColumns = [
    "vc_StockCode",
    "vc_StockName",
    "mon_StockPrice",
    "mon_SalesPrice",
    "FK_StockCategory_ID",
    "vc_Barcode",
    "dec_Quantity",
    "dec_FreeStock",
    "dec_UnitWeight",
    "dec_Allocated",
    "dec_OnOrder",
    "psync",
    "StockType",
    "ModifiedBy",
  ];

  const columnOptions = [
    { value: "vc_StockCode", label: "Product Code" },
    { value: "vc_StockName", label: "Description" },
    { value: "mon_StockPrice", label: "Cost Price" },
    { value: "mon_SalesPrice", label: "Sales Price" },
    { value: "FK_StockCategory_ID", label: "Discount Category" },

    { value: "vc_Barcode", label: "Barcode" },
    { value: "dec_Quantity", label: "In Stock" },
    { value: "dec_FreeStock", label: "Free Stock" },
    { value: "dec_UnitWeight", label: "Weight" },
    { value: "dec_Allocated", label: "Allocated" },
    { value: "dec_OnOrder", label: "On Order" },
    { value: "UpdatedDate", label: "Updated Date" },
    { value: "psync", label: "Sync" },
    { value: "StockType", label: "Type" },
    { value: "ModifiedBy", label: "ModifiedBy" },

  ];
  const getStoredColumns = () => {
    const storedColumns = Cookies.get(`PartsColumns_${CompanyID}`);
    return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
  };

  const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
  const handleColumnChange = (selectedOptions) => {
    setVisibleColumns(selectedOptions);

    // Save selection to cookies (valid for 1 year)
    Cookies.set(`PartsColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
  };
  const handlePartMovment = () => {
    setStockID(multipleIds);
    setIsMovementModalOpen(true);
  };

  const defaultColumnsForSearch = [
    "vc_StockCode",
    "vc_StockName",
    "mon_StockPrice",
    "mon_SalesPrice",
    "FK_StockCategory_ID",
    "vc_Barcode",
    "dec_Quantity",
    "dec_FreeStock",
    "dec_UnitWeight",
    "dec_Allocated",
    "dec_OnOrder",
    "psync",
    "StockType",
    "ModifiedBy"
  ];
  const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
  const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
  const columnSearchOptions = [
    { value: "vc_StockCode", label: "Product Code" },
    { value: "vc_StockName", label: "Description" },
    { value: "mon_StockPrice", label: "Cost Price" },
    { value: "mon_SalesPrice", label: "Sales Price" },
    { value: "FK_StockCategory_ID", label: "Discount Category" },

    { value: "vc_Barcode", label: "Barcode" },
    { value: "dec_Quantity", label: "In Stock" },
    { value: "dec_FreeStock", label: "Free Stock" },
    { value: "dec_UnitWeight", label: "Weight" },
    { value: "dec_Allocated", label: "Allocated" },
    { value: "dec_OnOrder", label: "On Order" },
    { value: "UpdatedDate", label: "Updated Date" },
    { value: "psync", label: "Sync" },
    { value: "StockType", label: "Type" },
    { value: "ModifiedBy", label: "ModifiedBy" },


  ];
  const handleSearchColumnChange = (selectedOptions) => {
    setSearchColumns(selectedOptions);

  };

  const handleExportExcel = async () => {

    if (multipleIds.length === 0) {
      Swal.fire(
        'Warning!',
        'Please select at least one record to export.',
        'warning'
      );
      return;
    }
    setLoading(true);
    try {
      debugger;
      // Filter only selected customers
      const selectedPart = filteredParts.filter(part =>
        multipleIds.includes(part.PK_Stock_ID)
      );

      if (!selectedPart || selectedPart.length === 0) {
        Swal.fire(
          'Warning!',
          'No selected data to export.',
          'warning'
        );
        return;
      }

      const fieldsData = await ImportTableService.GetAllImportFields(redirectCallback, "12");

      const fields = fieldsData.filter(
        field => field && (field.vc_FieldName || field.vc_DisplayName)
      );

      if (!fields || fields.length === 0) {
        Swal.fire(
          'Warning!',
          'No field definitions found for export.',
          'warning'
        );
        return;
      }
      const headers = fields.map(field => field.vc_DisplayName || field.vc_FieldName || field);
      const validSelectedParts = selectedPart.filter(
        asset => asset && Object.keys(asset).length > 0
      );

      const rows = validSelectedParts.map(row =>
        fields.map(field => {
          const col = field.vc_FieldName || field;
          let value = row[col];

          if (col === "FK_UnitOfMeasure_ID_Sales") value = row.Measurment ?? "";
          if (col === "FK_UnitOfMeasure_ID_Purchasing") value = row.PurchaseMeasurement ?? "";
          if (col === "ABranchName") value = row.BranchName ?? "";
          if (col === "FK_AssetSubCategory_ID") value = row.SubCategoryName ?? "";
          if (col === "snt_AssetCat") value = row.AssetCategory ?? "";

          return `"${String(value ?? '').replace(/"/g, '""')}"`;
        }).join(',')
      );
      const csvContent = [
        headers.join(','), // CSV Header
        ...rows            // CSV Rows
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Parts.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error exporting selected customers:', error);
    } finally {
      setLoading(false);
    }
  };
  const [lastCheckedIndex, setLastCheckedIndex] = useState(null);

  // NEW: handle click (not change)
  const handleCheckboxClick = (event, id, index) => {
    event.stopPropagation();

    const isChecked = event.target.checked;

    if (event.shiftKey && lastCheckedIndex !== null) {
      const start = Math.min(lastCheckedIndex, index);
      const end = Math.max(lastCheckedIndex, index);
      const idsInRange = filteredParts.slice(start, end + 1).map(l => l.PK_Stock_ID);

      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) {
          idsInRange.forEach(x => s.add(x));     // range select
        } else {
          idsInRange.forEach(x => s.delete(x));  // range unselect
        }
        return Array.from(s);
      });
    } else {
      // normal single toggle
      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) s.add(id); else s.delete(id);
        return Array.from(s);
      });
    }

    // Always update the anchor index
    setLastCheckedIndex(index);
  };

  const getInitialWidths = () => {
    const saved = Cookies.get(`PartColumnWidths_${CompanyID}_${UserID}`);
    const defaults = {};

    visibleColumns.forEach(col => {
      defaults[col] = 110;
    });

    if (!saved) return defaults;

    const parsed = JSON.parse(saved);
    const applied = {};

    visibleColumns.forEach(col => {
      applied[col] = parsed[col] || 110;
    });

    return applied;
  };

  const [columnWidths, setColumnWidths] = useState(getInitialWidths);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const resizingColumn = useRef(null);
  const MIN_COL_WIDTH = 60;

  /**
   * Load widths from cookie when visibleColumns changes
   */
  useEffect(() => {
    const savedWidths = Cookies.get(`PartColumnWidths_${CompanyID}_${UserID}`);
    if (savedWidths) {
      const parsed = JSON.parse(savedWidths);
      setColumnWidths((prev) => ({
        ...prev,
        ...parsed
      }));
    }
  }, [partList]);


  /**
   * Start Column Resize
   */
  const startResize = (e, key) => {
    e.stopPropagation();
    startX.current = e.clientX;
    resizingColumn.current = key;

    const th = e.target.closest("th");   // FIXED HERE
    startWidth.current = th.offsetWidth;

    document.addEventListener("mousemove", resizeColumn);
    document.addEventListener("mouseup", stopResize);
  };

  /**
   * Resize Column dynamically
   */
  const resizeColumn = (e) => {
    if (!resizingColumn.current) return;

    const delta = e.clientX - startX.current;
    const newWidth = Math.max(startWidth.current + delta, MIN_COL_WIDTH);

    setColumnWidths(prev => ({
      ...prev,
      [resizingColumn.current]: newWidth
    }));
  };
  useEffect(() => {
    setColumnWidths(getInitialWidths());
  }, [visibleColumns]);

  /**
   * Stop resizing and save to cookie
   */
  const stopResize = () => {
    document.removeEventListener("mousemove", resizeColumn);
    document.removeEventListener("mouseup", stopResize);

    const key = resizingColumn.current;
    if (key) {
      setColumnWidths(prev => {
        // Save using the most recent updated state
        Cookies.set(
          `PartColumnWidths_${CompanyID}_${UserID}`,
          JSON.stringify(prev),
          { expires: 365 }
        );
        return prev;
      });
    }

    resizingColumn.current = null;
  };


  /**
   * Auto-fit column width
   */
  const autoFitColumn = (key) => {
    const cells = document.querySelectorAll(`[data-col='${key}']`);
    let maxWidth = 0;

    cells.forEach(cell => {
      maxWidth = Math.max(maxWidth, cell.scrollWidth);
    });

    const newWidth = maxWidth + 20;

    const updated = { ...columnWidths, [key]: newWidth };

    setColumnWidths(updated);

    Cookies.set(
      `PartColumnWidths_${CompanyID}_${UserID}`,
      JSON.stringify(updated),
      { expires: 365 }
    );
  };

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [reportTitle, setReportTitle] = useState('');
  const [reportLink, setReportLink] = useState('');
  const [inputValues, setInputValues] = useState({});
  const [outputData, setOutputData] = useState([]);
  const [error, setError] = useState(null);
  const getMergedPDFBytes = async (id) => {
    try {
      const currentInputValues = {
        ClientID: localStorage.getItem("CompanyID"),
        ID: id
      };

      const redirectCallback = () => navigate('/');

      let reportData = await ReportService.GetCompanyReports(redirectCallback, "4");
      reportData = reportData.filter(x => x.IsDefault.toString() === "1");

      const reportID = reportData.length > 0 ? reportData[0].ID : 122;
      const JasperReport = await JasperReportService.GetJasperReportByID(reportID);

      const queryObjMain = {
        ...currentInputValues,
        format: 'pdf',
        ReportName: JasperReport[0].ReportName,
        ReportType: JasperReport[0].ReportType,
        name: JasperReport[0].ReportName
      };

      const responseMain = await axiosInstance.get(
        `/Dashboard/ProxyReport?${new URLSearchParams(queryObjMain)}`,
        { responseType: 'blob' }
      );

      const mainPdfBytes = await responseMain.data.arrayBuffer();

      const pdfDoc = await PDFDocument.load(mainPdfBytes);

      return pdfDoc;

    } catch (err) {
      console.error(err);
      return null;
    }
  };
  const handlePrintUser = async (event) => {
    event.stopPropagation();


    setLoading(true);
    const includeTerms = false;

    if (multipleIds.length > 0) {
      try {
        const finalMergedPdf = await PDFDocument.create();

        // ================= MERGE INVOICES =================
        for (const id of multipleIds) {

          const pdfDoc = await getMergedPDFBytes(id);

          if (!pdfDoc) continue;

          const pages = await finalMergedPdf.copyPages(
            pdfDoc,
            pdfDoc.getPageIndices()
          );

          pages.forEach(page => finalMergedPdf.addPage(page));
        }

        const finalBytes = await finalMergedPdf.save();
        const finalBlob = new Blob([finalBytes], { type: "application/pdf" });

        const finalUrl = URL.createObjectURL(finalBlob);
        setLoading(false);
        setPdfUrl(finalUrl);
        setShowPdfModal(true);

      } catch (err) {
        console.error('Error executing report:', err);
        setError('Failed to execute the report.');
      }
    } else {
      Swal.fire(
        'Error!',
        'Please check at least one record to print job.',
        'warning'
      );
    }
  };

  const handlePartDiscount = async (event) => {
    event.stopPropagation();
    try {
      setIsStockDiscount(true);

    } catch (err) {
      console.error('Error executing report:', err);
      setError('Failed to execute the report.');
    }

  };

  const handleStart = (e, ui) => {
    e.stopPropagation();
  }
  const handleStockCategoryCloseModal = () => {

    setIsStockDiscount(false);
  };
  return (
    <div>
      <Common
        showAddButton={'yes'}
        handleAddTask={handleCreatePartClick}
        showDeleteButton={'yes'} handleDeleteItem={handleDeleteClick}
        ModuleID={"4"}
        showSynchronize={'yes'} handleSynchronize={handleSynchronize}
        showSerialButton={'yes'} handleSerialTracking={handleSerialTracking}
        showBatchButton={'yes'} handleBatchManagement={handleBatchManagement}
        showPartMovment={'yes'} handlePartMovment={handlePartMovment}
        showExportButton={'yes'} handleExportExcel={handleExportExcel}
        isDisabled={multipleIds.length > 1}
        showPrintUser={'yes'} handlePrintUser={handlePrintUser}
        showPartDiscountButton={'yes'} handlePartDiscount={handlePartDiscount}
        HelpFormName="Part List" HelpModule="5"
        RecordID={multipleIds} />
      {loading && (
        <div class="loading">
          <div class="d-table">
            <div class="d-tablecell">
              <span class="loader">
                <span class="loader-inner"></span>
              </span>
            </div>
          </div>
        </div>
      )}
      <div className="main-content-header">
        <div className="row" style={{ "marginLeft": "0px", "marginRight": "0px" }}>
          <div className="col-xl-2">
            <h1>{t('parts')}</h1>
          </div>

          <div className="col-xl-10 d-flex justify-content-end">
            <ColumnOptionDropDown
              options={columnOptions}
              selectedOptions={visibleColumns}
              onChange={handleColumnChange}
            />
            <button onClick={() => filterParts('red')} style={{ "background": "red", "color": "#ffffff", backgroundColor: "#FFC107" }} className="btn btn-info">{t('belowMinStock')}</button>
            <button onClick={() => filterParts('blue')} style={{ "background": "blue", "color": "#ffffff", "marginLeft": "5px", backgroundColor: "#0D6EFD" }} className="btn btn-info">{t('aboveMaxStock')}</button>
            <button onClick={() => filterParts('all')} style={{ "background": "#333", "color": "#ffffff", "marginLeft": "5px", backgroundColor: "#6C757D", marginRight: "5px" }} className="btn btn-info">{t('allStock')}</button>

          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card mb-30">
            <div className="card-body">

              <div className="table-responsive" style={{ overflow: "visible" }}>
                <div className="row mb-3">
                  <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>
                  <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                  <div className="col-sm-6"></div>
                  <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>

                    <MultiSearchDropDown
                      options={columnSearchOptions}
                      selectedOptions={searchColumns}
                      onChange={handleSearchColumnChange}
                    />
                  </div>
                  <div className="col-sm-2 d-flex justify-content-end">
                    <input
                      list="recent-searches"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="form-control me-2"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleSearchButtonClick();
                        }
                      }}
                    />
                    <datalist id="recent-searches">
                      {recentSearches.map((item, idx) => (
                        <option key={idx} value={item.SearchQuery} />
                      ))}
                    </datalist>
                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                      <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                  </div>



                </div>
                <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                  <table
                    style={{
                      tableLayout: "fixed",
                      width: "max-content",
                      minWidth: "100%"
                    }}
                    className="table m-0 table-hover"
                    ref={tableRef}
                  >
                    <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                      <tr>
                        <th
                          className="checkbox-header"
                          style={{
                            width: "40px",
                            minWidth: "40px",
                            maxWidth: "40px",
                            position: "sticky",
                            left: 0,
                            zIndex: 5,

                          }}
                        ></th>
                        {visibleColumns.includes("vc_StockCode") &&
                          <th onClick={() => handleSort('vc_StockCode')}
                            style={{
                              width: `${columnWidths?.vc_StockCode}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Part Code
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_StockCode'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_StockCode");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_StockCode")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("vc_StockName") &&
                          <th onClick={() => handleSort('vc_StockName')}

                            style={{
                              width: `${columnWidths?.vc_StockName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('description')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_StockName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_StockName");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_StockName")}
                            /></th>
                        }
                        {visibleColumns.includes("StockType") &&
                          <th onClick={() => handleSort('StockType')}

                            style={{
                              width: `${columnWidths?.StockType}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('StockType')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'StockType'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "StockType");
                              }}
                              onDoubleClick={() => autoFitColumn("StockType")}
                            /></th>
                        }
                        {visibleColumns.includes("mon_StockPrice") &&
                          <th onClick={() => handleSort('mon_StockPrice')}

                            style={{
                              width: `${columnWidths?.mon_StockPrice}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('costPrice')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'mon_StockPrice'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "mon_StockPrice");
                              }}
                              onDoubleClick={() => autoFitColumn("mon_StockPrice")}
                            /></th>
                        }
                        {visibleColumns.includes("mon_SalesPrice") &&
                          <th onClick={() => handleSort('mon_SalesPrice')}

                            style={{
                              width: `${columnWidths?.mon_SalesPrice}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Sales Price<i
                              className={`ms-1 icofont ${sortConfig.key === 'mon_SalesPrice'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "mon_SalesPrice");
                              }}
                              onDoubleClick={() => autoFitColumn("mon_SalesPrice")}
                            /></th>
                        }
                        {visibleColumns.includes("FK_StockCategory_ID") &&
                          <th onClick={() => handleSort('FK_StockCategory_ID')}

                            style={{
                              width: `${columnWidths?.FK_StockCategory_ID}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('discountCategory')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'FK_StockCategory_ID'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "FK_StockCategory_ID");
                              }}
                              onDoubleClick={() => autoFitColumn("FK_StockCategory_ID")}
                            /></th>
                        }

                        {visibleColumns.includes("vc_Barcode") &&
                          <th onClick={() => handleSort('vc_Barcode')}

                            style={{
                              width: `${columnWidths?.vc_Barcode}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Barcode<i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_Barcode'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_Barcode");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_Barcode")}
                            /></th>
                        }
                        {visibleColumns.includes("dec_UnitWeight") &&
                          <th onClick={() => handleSort('dec_UnitWeight')}

                            style={{
                              width: `${columnWidths?.dec_UnitWeight}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Weight<i
                              className={`ms-1 icofont ${sortConfig.key === 'dec_UnitWeight'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "dec_UnitWeight");
                              }}
                              onDoubleClick={() => autoFitColumn("dec_UnitWeight")}
                            /></th>
                        }
                        {visibleColumns.includes("dec_Quantity") &&
                          <th onClick={() => handleSort('dec_Quantity')}

                            style={{
                              width: `${columnWidths?.dec_Quantity}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('inStock')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'dec_Quantity'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "dec_Quantity");
                              }}
                              onDoubleClick={() => autoFitColumn("dec_Quantity")}
                            /></th>
                        }
                        {visibleColumns.includes("dec_FreeStock") &&
                          <th onClick={() => handleSort('dec_FreeStock')}

                            style={{
                              width: `${columnWidths?.dec_FreeStock}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('freeStock')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'dec_FreeStock'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "dec_FreeStock");
                              }}
                              onDoubleClick={() => autoFitColumn("dec_FreeStock")}
                            /></th>
                        }
                        {visibleColumns.includes("dec_Allocated") &&
                          <th onClick={() => handleSort('dec_Allocated')}

                            style={{
                              width: `${columnWidths?.dec_Allocated}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('allocated')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'dec_Allocated'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "dec_Allocated");
                              }}
                              onDoubleClick={() => autoFitColumn("dec_Allocated")}
                            /></th>
                        }
                        {visibleColumns.includes("dec_OnOrder") &&
                          <th onClick={() => handleSort('dec_OnOrder')}

                            style={{
                              width: `${columnWidths?.dec_OnOrder}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('onOrder')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'dec_OnOrder'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "dec_OnOrder");
                              }}
                              onDoubleClick={() => autoFitColumn("dec_OnOrder")}
                            /></th>
                        }
                        {visibleColumns.includes("UpdatedDate") &&
                          <th onClick={() => handleSort('UpdatedDate')}

                            style={{
                              width: `${columnWidths?.UpdatedDate}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Last Action
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'UpdatedDate'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "UpdatedDate");
                              }}
                              onDoubleClick={() => autoFitColumn("UpdatedDate")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("ModifiedBy") &&
                          <th onClick={() => handleSort('ModifiedBy')}
                            style={{
                              width: `${columnWidths?.ModifiedBy}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Modified By
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'ModifiedBy'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "ModifiedBy");
                              }}
                              onDoubleClick={() => autoFitColumn("ModifiedBy")}
                            />
                          </th>
                        }

                        {visibleColumns.includes("psync") &&
                          <th

                            style={{
                              width: `${columnWidths?.psync}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('sync')}</th>
                        }
                      </tr>
                    </thead>


                    <tbody>
                      {filteredParts.map((part, index) => (

                        <tr
                          key={part.PK_Stock_ID}
                          onClick={() => handleEditClick(part.PK_Stock_ID)}
                          style={{
                            backgroundColor: selectedId.toString() === part.PK_Stock_ID.toString() ? 'rgb(197, 218, 237)' : '', // Highlight background
                            cursor: 'pointer',
                          }}
                        >
                          <td
                            className="checkbox-cell"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              width: "40px",
                              minWidth: "40px",
                              maxWidth: "40px",
                              position: "sticky",
                              left: 0,
                              zIndex: 3,
                              backgroundColor:
                                selectedId.toString() === part.PK_Stock_ID.toString()
                                  ? 'rgb(197, 218, 237)'
                                  : '#fff'
                            }}
                          >
                            <div
                              className="checkbox-hover-area"
                              onClick={(event) => handleCheckboxClick(event, part.PK_Stock_ID, index)}
                            >
                              <input
                                type="checkbox"
                                checked={multipleIds.includes(part.PK_Stock_ID)}
                                readOnly
                              />
                            </div>
                          </td>
                          {visibleColumns.includes("vc_StockCode") && <td style={{
                            width: columnWidths.vc_StockCode,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }} >{part.vc_StockCode}</td>}
                          {visibleColumns.includes("vc_StockName") && <td style={{
                            width: columnWidths.vc_StockName,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }} title={part.vc_Description}>{part.vc_Description}</td>}

                          {visibleColumns.includes("StockType") && <td style={{
                            width: columnWidths.StockType,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }} title={part.StockStatus}>{part.StockStatus}</td>}
                          {visibleColumns.includes("mon_StockPrice") && <td style={{
                            width: columnWidths.mon_StockPrice,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }}>{part.Symbol}{part.mon_StockPrice}</td>}
                          {visibleColumns.includes("mon_SalesPrice") && <td style={{
                            width: columnWidths.mon_SalesPrice,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }}>{part.Symbol}{part.mon_SalesPrice}</td>}
                          {visibleColumns.includes("FK_StockCategory_ID") && <td style={{
                            width: columnWidths.FK_StockCategory_ID,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }}>{part.FK_StockCategory_ID ? part.FK_StockCategory_ID : "None"}</td>}

                          {visibleColumns.includes("vc_Barcode") && <td style={{
                            width: columnWidths.vc_Barcode,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }} title={part.vc_Barcode}>{part.vc_Barcode}</td>}
                          {visibleColumns.includes("dec_UnitWeight") && <td style={{
                            width: columnWidths.dec_UnitWeight,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }} title={part.dec_UnitWeight}>{part.dec_UnitWeight}</td>}
                          {visibleColumns.includes("dec_Quantity") && (
                            <td
                              style={{
                                width: columnWidths.dec_Quantity,
                                minWidth: MIN_COL_WIDTH,
                                color: getRowColor(
                                  part.dec_FreeStock,
                                  part.dec_MinimumQuantity,
                                  part.dec_MaximumQuantity
                                ),
                              }}
                              className="no-wrap ellipsis"
                            >
                              {part.StockType.toString() === "0"
                                ? "NA"
                                : `${parseFloat(part.dec_Quantity ?? 0).toFixed(part.DecimalPlaces ?? 0)} ${part.Measurment}`}
                            </td>
                          )}
                          {visibleColumns.includes("dec_FreeStock") && <td style={{
                            width: columnWidths.dec_FreeStock,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }}>
                            {part.StockType.toString() === "0"
                              ? "NA"
                              : `${parseFloat(part.dec_FreeStock ?? 0).toFixed(part.DecimalPlaces ?? 0)} ${part.Measurment}`
                            }
                          </td>}
                          {visibleColumns.includes("dec_Allocated") && <td style={{
                            width: columnWidths.vc_Company,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }}>
                            {part.StockType.toString() === "0"
                              ? "NA"
                              : `${parseFloat(part.dec_Allocated ?? 0).toFixed(part.DecimalPlaces ?? 0)} ${part.Measurment}`
                            }
                          </td>}
                          {visibleColumns.includes("dec_OnOrder") && <td style={{
                            width: columnWidths.vc_Company,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }}>
                            {part.StockType.toString() === "0"
                              ? "NA"
                              : `${parseFloat(part.dec_OnOrder ?? 0).toFixed(part.DecimalPlaces ?? 0)} ${part.Measurment}`}</td>}
                          {visibleColumns.includes("UpdatedDate") && <td style={{
                            width: columnWidths.UpdatedDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDateWithFns(part.UpdatedDate, activeDateFormat)}  </td>}
                          {visibleColumns.includes("ModifiedBy") && <td style={{
                            width: columnWidths.ModifiedBy,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {part.ModifiedBy ? (
                              <div
                                title={part.ModifiedBy}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#368938",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {part.ModifiedBy.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}
                          {visibleColumns.includes("psync") &&
                            <td style={{
                              width: columnWidths.psync,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis">
                              {part.IsSynced === 1 && (
                                <img src='assets/img/resources/tick.png' style={{ width: "20px" }}></img>
                              )}
                              {part.IsSynced === 2 && (
                                <img src='assets/img/resources/sync.JPG' style={{ width: "50px" }}></img>
                              )}
                            </td>
                          }
                        </tr>
                      ))}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                      <tr>
                        <td colSpan={visibleColumns.length + 1}>
                          <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                            Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(poCount, pageSize))} of {poCount} entries

                            {/* Last Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(totalPages)} // Navigate to last page
                              disabled={currentPage === totalPages}
                            >

                              <img src="assets/img/resources/last.png" alt="Add icon" style={{ height: "10px" }} /> Last
                            </button>

                            {/* Next Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} /> Next
                            </button>

                            <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                              Page {currentPage} of {totalPages}
                            </span>

                            {/* Previous Page Button */}
                            <button
                              style={{ float: "right", marginRight: "5px", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} /> Prev
                            </button>

                            {/* First Page Button */}
                            <button
                              style={{ float: "right" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(1)} // Navigate to first page
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/first.png" alt="Add icon" style={{ height: "10px" }} /> First
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>

                </div>
                {(isModalOpen &&
                  <PartsDetailModal StockID={localStorage.getItem('StockID')} onClose={handleCloseModal} onSuccess={fetchParts} />
                )}
                {isBatchModalOpen && (
                  <StockBatchSearchModal StockID={selectedId} onClose={handleBatchCloseModal} />
                )}
                {isSerialModalOpen && (
                  <SearchStockSerialModal StockID={selectedId} onClose={handleSerialCloseModal} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {(isMovementModalOpen &&
        <StockMovementModal show={true} close={() => setIsMovementModalOpen(false)} StockID={StockID} />
      )}
      {(isStockDiscount &&
        <StockCategoryListPage show={true} onClose={handleStockCategoryCloseModal} StockID={StockID} />
      )}




      {showPdfModal && pdfUrl && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <Draggable handle=".modal-content" onStart={handleStart}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">PDF Report</h5>
                  <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                </div>
              </div>
            </Draggable>
          </div>
        </div>
      )}

    </div>


  );
}
export default PartListPage;